import React, { useState, useEffect } from 'react';
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";

 
import useTable from "../../useTable";
import { ModalExpendio } from './modalAgregarExpendio';
import axios from 'axios';


function TablaIndole(props) {

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const headCells = [
        { id: '', label: 'CODIGO', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: '', label: 'DESCRIPCION INDOLE', width: '200px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: '', label: 'HORARIO', width: '300px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: '', label: 'LICENCIA', width: '300px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
        { id: '', label: 'OPCIONES', width: '150px', textAlign: "center", backgroundColor: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },

    ]

    /* variables de estado */
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [contar6, setContar6] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [comercio, setComercio] = useState();
    const [persona, setPersona] = useState();
    const [statusCome, setStatusCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [ipMac, setIpMac] = useState({ ip: localStorage.getItem('ip'), mac: localStorage.getItem('mac') });
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();
    const [horaope, setHoraope] = useState();
    const [declaWeb, setDeclaWeb] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mostarModal, setMostrarModal] = useState(false);
    const [idcomercio, setIdcomercio] = useState();
    const [expendio, setExpendio] = useState();
    const [desabiliatar, setDesabilitar] = useState()

    const abrirContri = () => {
        setMostrarModal(true);
    }

    const cerrarContri = () => {
        setMostrarModal(false);
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    /* metodo para filtrar la tabla */
    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idagenteretencion.includes(target.value)
                            || x.ritm.toLowerCase().includes(target.value.toLowerCase())
                            || x.rif.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || x.reprelegal.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    };



    /* metodo para cerrar el dialogo de mensaje */

    const handleCloseMensa = () => {
        setMostrar(false);
    }


    useEffect(() => {


        if (props.indole) {
            setRecords(props.indole);
            setIdcomercio(props.idcomercio)
            setDesabilitar(props.desabilitar)
        }


    }, [props.indole]);

    const opciones = (ope, item) => (event) => {

        event.preventDefault();
        if (ope === 1) {

            setMostrarModal(true);
            setOperacion(1);
            console.log('1')

        } else if (ope === 3) {

            setOperacion(3);
            setExpendio(item)
            setMostrarModal(true);
           

        }


    }



    return (
        <div className="card">

            <ModalExpendio
                show={mostarModal}
                onHideCancela={cerrarContri}
                operacion={operacion}
                expendio={expendio}
                idcomercio={idcomercio}
                onHideRenderIndole={props.onHideRenderIndole}
                onHideRenderDeu={props.onHideRenderDeu}
                comercio={props.comercio}
            />

            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            {/* /.card-header */}
            <div className="card-body">
                <div className="content" >
                    <div className="">

                        <div className="row col-md-12 mx-auto">

                            <div className='col-md-10'></div>

                            <div className='col-md-2'>

                                <div className="col-md-12 d-flex justify-content-end">
                                    <button disabled={props.disabled === true ? false : true} style={{ marginBottom: "10px" }} onClick={opciones(1, '')} className="btn btn-sm btn-primary rounded-pill"><i className="fas fa-plus"><small>Incluir</small></i> </button>
                                </div>

                            </div>

                            <div className="col-md-12" style={{ margin: "auto" }} >
                            <TblContainer container={{ height: 250, width: '100%', overflow: 'auto', padding: '2px' }} >

                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idcomercio} style={{ padding: "0", height: '40px' }}>
                                                    <td className='align-baseline' style={{ fontSize: "10px", textAlign: "center", width: "10px", height: '40px' }}>{item.idtipoexpendio}</td>
                                                    <td className='align-baseline' style={{ fontSize: "10px", textAlign: "left", width: "200px", height: '40px' }}>{item.descripcion}</td>
                                                    <td className='align-baseline' style={{ fontSize: "10px", textAlign: "center", width: "200px", height: '40px' }}>{"Desde: " + item.horaabierto + ' ' + item.apabierto + 'hasta: ' + item.horacerrado + ' ' + item.apcerrado}</td>
                                                    <td className='align-baseline' style={{ fontSize: "10px", textAlign: "left", width: "200px", height: '40px' }}>{item.licencia}</td>
                                                    <td className='align-baseline' style={{ fontSize: "10px", textAlign: "center", width: "40px", height: '40px' }}>
                                                        <button style={{ pointerEvents: permiso && permiso.substring(3, 4) !== "1" ? 'none' : '' }} disabled={props.disabled === true ? false : true} onClick={opciones(3, item)} className="btn btn-sm btn-danger rounded-circle"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>




                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>

                        </div>

                    </div>
                </div>

             
            </div>

        </div>

    );

}

export default TablaIndole;
